import { render, staticRenderFns } from "./FakeSite.vue?vue&type=template&id=18580015&"
import script from "./FakeSite.vue?vue&type=script&lang=js&"
export * from "./FakeSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports